import { useEffect, useState } from 'react';


export function usePartNameInUrl() {

    const [partName, setPartName] = useState<string>('');


    //Set selected partName from url hash
    useEffect(() => {
        const hashParams = new URLSearchParams(window.location.hash.substring(1));
        const partName = hashParams.get('partName');
        if (partName) {
            setPartName(partName);
        }
    }, [setPartName]);


    const handlePartNameSubmit = (partName: string) => {
        setPartName(partName);
        setUrlHash(partName ? 'partName=' + partName : '');
    }

    const setUrlHash = (hash: string) => {
        history.replaceState(null, '', document.location.pathname + '#' + hash);
    }

    return {
        partName,
        setPartName: handlePartNameSubmit,
    };
}
